import { Card, CardHeader, CardDescription, CardTitle } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { TrendingDown, TrendingUp } from 'lucide-react';
import { formatCurrency, formatPercent } from '@/lib/utils/formatters';
import { useGestaoImpostosContext } from '@/contexts';

export function KpisPanel() {
  const { isLoadingSituacaoAtual, totalVendas, projecaoAnoAtual, projecaoCompleta } =
    useGestaoImpostosContext();

  const cargaFinal = projecaoCompleta?.anos[projecaoCompleta.anos.length - 1] ?? null;
  const variacaoPP =
    projecaoAnoAtual && cargaFinal
      ? projecaoAnoAtual.total.percentualSobreVendas - cargaFinal.total.percentualSobreVendas
      : null;

  return (
    <div className="grid gap-6 md:grid-cols-4 mb-8">
      <Card>
        <CardHeader className="pb-3">
          <CardDescription>Total de Vendas</CardDescription>
          {isLoadingSituacaoAtual || totalVendas === null ? (
            <Skeleton className="h-8 w-32" />
          ) : (
            <CardTitle className="text-2xl">{formatCurrency(totalVendas)}</CardTitle>
          )}
        </CardHeader>
      </Card>
      <Card>
        <CardHeader className="pb-3">
          <CardDescription>Total de Impostos</CardDescription>
          {isLoadingSituacaoAtual || !projecaoAnoAtual ? (
            <Skeleton className="h-8 w-32" />
          ) : (
            <CardTitle className="text-2xl text-red-600">
              {formatCurrency(projecaoAnoAtual.total.valor)}
            </CardTitle>
          )}
        </CardHeader>
      </Card>
      <Card>
        <CardHeader className="pb-3">
          <CardDescription>Carga Tributária Atual</CardDescription>
          {isLoadingSituacaoAtual || !projecaoAnoAtual ? (
            <Skeleton className="h-8 w-24" />
          ) : (
            <CardTitle className="text-2xl text-primary">
              {formatPercent(projecaoAnoAtual.total.percentualSobreVendas)}
            </CardTitle>
          )}
        </CardHeader>
      </Card>
      <Card>
        <CardHeader className="pb-3">
          <CardDescription>Carga Tributária 2033</CardDescription>
          {isLoadingSituacaoAtual || !cargaFinal ? (
            <Skeleton className="h-8 w-24" />
          ) : (
            <>
              <CardTitle className="text-2xl text-green-600">
                {formatPercent(cargaFinal.total.percentualSobreVendas)}
              </CardTitle>
              {variacaoPP !== null && (
                <div
                  className={`flex items-center gap-1 text-sm mt-1 ${variacaoPP >= 0 ? 'text-red-600' : 'text-green-600'}`}
                >
                  {variacaoPP >= 0 ? (
                    <TrendingUp className="h-4 w-4" />
                  ) : (
                    <TrendingDown className="h-4 w-4" />
                  )}
                  <span>{formatPercent(Math.abs(variacaoPP)).replace('%', ' p.p.')}</span>
                </div>
              )}
            </>
          )}
        </CardHeader>
      </Card>
    </div>
  );
}
